import { triggerLoading } from "@/utils/loadingManager";

/**
 * Higher-order function to automatically handle loading state
 * @param callback Asynchronous function that you want to execute with loading handling
 * @returns Returns the result of the function passed as callback
 */
export const withLoading = async <T>(
  callback: () => Promise<T>
): Promise<T> => {
  try {
    triggerLoading(true);
    return await callback();
  } finally {
    triggerLoading(false);
  }
};
